document.addEventListener("DOMContentLoaded", () => {
  const categoryToggle = document.querySelector(".category-toggle");
  const categoryOffcanvas = document.querySelector(".category-offcanvas");
  const categoryOffcanvasClose = document.querySelector(
    ".category-offcanvas-close"
  );
  const categoryOffcanvasOverlay = document.querySelector(
    ".category-offcanvas-overlay"
  );
  const categoryOffcanvasContent = document.querySelector(
    ".category-offcanvas-content"
  );

  // Get scrollbar width to prevent page jump
  const getScrollbarWidth = () => {
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  };

  const openOffcanvas = (e) => {
    e.preventDefault();
    const scrollbarWidth = getScrollbarWidth();
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    categoryOffcanvas.classList.add("active");
    categoryToggle.classList.add("active");
    document.body.classList.add("offcanvas-open");
  };

  const closeOffcanvas = (e) => {
    if (e) {
      e.preventDefault();
    }

    categoryOffcanvas.classList.remove("active");
    categoryToggle.classList.remove("active");

    // Wait for transition to complete before removing body class and padding
    setTimeout(() => {
      document.body.classList.remove("offcanvas-open");
      document.body.style.paddingRight = "";
    }, 300); // Match this with your CSS transition duration
  };

  if (categoryToggle && categoryOffcanvas) {
    categoryToggle.addEventListener("click", openOffcanvas);
    categoryOffcanvasClose.addEventListener("click", closeOffcanvas);
    categoryOffcanvasOverlay.addEventListener("click", closeOffcanvas);

    // Close on escape key
    document.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape" &&
        categoryOffcanvas.classList.contains("active")
      ) {
        closeOffcanvas();
      }
    });

    // Prevent clicks inside offcanvas from closing it
    categoryOffcanvasContent.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  }
});
